export const WATERMARK_TYPE = {
  DISABLED: 0,
  LOGO: 1,
  TEXT: 2,
  UPLOAD: 3,
};

export const WATERMARK_FONTS = [
  { label: 'Montserrat Bold', value: 0 },
  { label: 'Oleo Script Regular', value: 1 },
  { label: 'Merriweather Black', value: 2 },
];

export const WATERMARK_VERTICAL_NUDGE_TYPES = [
  { label: 'To the left', value: 0 },
  { label: 'To the right', value: 1 },
];

export const WATERMARK_HORIZONTAL_NUDGE_TYPES = [
  { label: 'Lower', value: 0 },
  { label: 'Upper', value: 1 },
];

export const DEFAULT_GALLERY_VIEW_OPTION = [
  { label: 'Slider', value: 0 },
  { label: 'Morph', value: 1 },
  { label: 'Side-by-side', value: 2 },
];

export const WATERMARK_POSITION = {
  LEFT_TOP: 0,
  LEFT_CENTER: 1,
  LEFT_BOTTOM: 2,
  CENTER_TOP: 3,
  CENTER: 4,
  CENTER_BOTTOM: 5,
  RIGHT_TOP: 6,
  RIGHT_CENTER: 7,
  RIGHT_BOTTOM: 8,
};

export const GALLERY_ITEM_TYPES = {
  GIF: 'gif',
  SINGLE_IMAGE: 'single image',
  PAIR: 'pair',
  BUNDLE: 'bundle',
};

export const GALLERY_ACTIONS = {
  CLONE: 'Clone',
  MOVE: 'Move',
};
